import { render, staticRenderFns } from "./SeminarHeader.vue?vue&type=template&id=7f12c8e0&scoped=true"
import script from "./SeminarHeader.vue?vue&type=script&lang=ts"
export * from "./SeminarHeader.vue?vue&type=script&lang=ts"
import style0 from "./SeminarHeader.vue?vue&type=style&index=0&id=7f12c8e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f12c8e0",
  null
  
)

export default component.exports